import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'eyrus-questionnaire',
  templateUrl: './questionnaire.component.html',
  styleUrls: ['./questionnaire.component.sass']
})
export class QuestionnaireComponent implements OnInit {

  constructor() { 
  }

  ngOnInit() {
  }

}
